document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('bt-form');
  const wrapper = document.querySelector('.bt-wrapper');
  const visuals = document.querySelectorAll('.bt-visual-item');
  const submitBtn = document.querySelector('.bt-btn-submit'); 
  
  // UI Elements
  const loadingScreen = document.querySelector('.bt-loading-screen');
  const loadingTextEl = document.querySelector('.bt-loading-text');
  const allSteps = document.querySelectorAll('.bt-step'); 

  // Data Inputs
  const finalDestInput = document.getElementById('final-destination');
  const finalTypeInput = document.getElementById('final-type-result');

  // Textes
  const loadTxt1 = wrapper.dataset.load1 || "Analyse...";
  const loadTxt2 = wrapper.dataset.load2 || "Comparaison...";
  const loadTxt3 = wrapper.dataset.load3 || "Finalisation...";
  const nextText = wrapper.dataset.nextText || "Passons à la question suivante";
  const prevText = wrapper.dataset.prevText || "Retour à la question précédente";

  let quizScores = { A: 0, B: 0, C: 0 };
  let isSubmitting = false; 

  const urls = {
    type_A: wrapper.dataset.urlA,
    type_B: wrapper.dataset.urlB,
    type_C: wrapper.dataset.urlC
  };

  // --- 0. FONCTION AMNÉSIE (RESET TOTAL) ---
  function resetQuizState() {
    console.log("Quiz Reset Triggered");
    isSubmitting = false;
    quizScores = { A: 0, B: 0, C: 0 };
    
    // 1. Reset du formulaire
    if(form) form.reset();

    // 2. Déverrouiller tous les inputs
    const allInputs = document.querySelectorAll('input');
    allInputs.forEach(input => {
        input.disabled = false;
        input.checked = false;
    });

    // 3. Reset UI 
    if(loadingScreen) loadingScreen.classList.remove('visible');
    allSteps.forEach(step => {
        step.style.display = 'none';
        step.classList.remove('is-reversing');
        step.classList.remove('slide-out');
        step.classList.remove('active');
    });
    
    // Réactiver l'étape 1
    const step1 = document.querySelector('.bt-step[data-step="1"]');
    if(step1) {
        step1.style.display = 'flex';
        step1.classList.add('active');
        updateColors(step1);
    }
    
    // Reset visuel images
    visuals.forEach(v => v.classList.remove('active'));
    const vis1 = document.querySelector('.bt-visual-item[data-index="1"]');
    if(vis1) vis1.classList.add('active');
  }

  // --- DETECTEUR DE CACHE (ZOMBIE MOBILE) ---
  window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
          resetQuizState();
      }
  });
  
  // Reset initial par sécurité
  resetQuizState();

  // Injecter les textes de transition dans le CSS
  const style = document.createElement('style');
  style.textContent = `
    .bt-step:has(input[type="radio"]:checked)::after {
      content: "${nextText}";
    }
    .bt-step.is-reversing::after {
      content: "${prevText}";
    }
  `;
  document.head.appendChild(style);

  // --- 1. Gestion des Couleurs ---
  function updateColors(step) {
    if(!step) return;
    const isDesktop = window.innerWidth >= 992;
    
    if (isDesktop) {
      wrapper.style.setProperty('--bt-desk-bg', step.dataset.deskBg);
      wrapper.style.color = step.dataset.deskText;
      form.style.background = step.dataset.deskGlass;
      form.style.borderColor = step.dataset.deskBorder;
      wrapper.style.setProperty('--bt-desk-accent', step.dataset.deskAccent);
      
      const checkboxLabel = form.querySelector('label.bt-email-input');
      if(checkboxLabel) {
          checkboxLabel.style.background = step.dataset.deskGlass;
          checkboxLabel.style.borderColor = step.dataset.deskBorder;
      }
    } else {
      wrapper.style.color = step.dataset.mobText;
      form.style.background = step.dataset.mobGlass;
      form.style.borderColor = step.dataset.mobBorder;
      wrapper.style.setProperty('--bt-mob-accent', step.dataset.mobAccent);

      const checkboxLabel = form.querySelector('label.bt-email-input');
      if(checkboxLabel) {
          checkboxLabel.style.background = step.dataset.mobGlass;
          checkboxLabel.style.borderColor = step.dataset.mobBorder;
      }
    }
  }

  // --- 2. Gestion Visuels ---
  function updateVisual(index) {
    visuals.forEach(v => v.classList.remove('active'));
    if(index === 'email') {
       const emailVis = document.querySelector('.bt-visual-item[data-index="email"]');
       if(emailVis) emailVis.classList.add('active');
       return;
    }
    const target = document.querySelector(`.bt-visual-item[data-index="${index}"]`);
    if(target) target.classList.add('active');
  }

  // --- 3. Transitions ---
  function transitionTo(currentDiv, nextDiv, nextVisualIndex) {
    if(!currentDiv || !nextDiv) return;
    
    currentDiv.classList.remove('active');
    currentDiv.classList.add('slide-out');
    
    setTimeout(() => {
      currentDiv.style.display = 'none';
      currentDiv.classList.remove('slide-out');
      currentDiv.classList.remove('is-reversing');
      
      nextDiv.style.display = 'flex';
      updateColors(nextDiv);
      updateVisual(nextVisualIndex);
      setTimeout(() => nextDiv.classList.add('active'), 50);
    }, 700);
  }

  // --- 4. Logique Quiz (Suivant) ---
  document.querySelectorAll('.bt-option-input').forEach(input => {
    input.addEventListener('change', (e) => {
      
      const currentStepDiv = e.target.closest('.bt-step');
      
      // 1. Verrouillage immédiat
      const allInputsInStep = currentStepDiv.querySelectorAll('input');
      allInputsInStep.forEach(el => el.disabled = true);

      const currentStepNum = parseInt(currentStepDiv.dataset.step);
      const totalSteps = parseInt(wrapper.dataset.totalQuestions);
      
      // 2. Attente 2 secondes
      setTimeout(() => {
        if (currentStepNum < totalSteps) {
          const nextStepDiv = document.querySelector(`.bt-step[data-step="${currentStepNum + 1}"]`);
          transitionTo(currentStepDiv, nextStepDiv, currentStepNum + 1);
        } else {
          // 3. CALCUL FINAL
          let finalScores = { A: 0, B: 0, C: 0 };
          const allChecked = form.querySelectorAll('input[type="radio"]:checked');
          
          allChecked.forEach(radio => {
              if(radio.value === 'type_A') finalScores.A++;
              if(radio.value === 'type_B') finalScores.B++;
              if(radio.value === 'type_C') finalScores.C++;
          });

          let winner = 'type_A'; 
          if(finalScores.B > finalScores.A && finalScores.B > finalScores.C) winner = 'type_B';
          if(finalScores.C > finalScores.A && finalScores.C > finalScores.B) winner = 'type_C';
          
          if(finalDestInput) finalDestInput.value = urls[winner];
          if(finalTypeInput) finalTypeInput.value = winner; 
          
          transitionTo(currentStepDiv, document.querySelector('.bt-step[data-step="email"]'), 'email');
        }
      }, 2000); 
    });
  });

  // --- 5. Navigation Retour ---
  document.querySelectorAll('.bt-btn-prev').forEach(btn => {
    btn.addEventListener('click', (e) => {
       const currentStepDiv = e.target.closest('.bt-step');
       const stepAttr = currentStepDiv.dataset.step;
       
       if(stepAttr === '1') return;

       currentStepDiv.classList.add('is-reversing');

       setTimeout(() => {
           if(stepAttr === 'email') {
             const totalSteps = parseInt(wrapper.dataset.totalQuestions);
             const prevStep = document.querySelector(`.bt-step[data-step="${totalSteps}"]`);
             prevStep.querySelectorAll('input').forEach(i => { i.disabled = false; i.checked = false; });
             transitionTo(currentStepDiv, prevStep, totalSteps);
           } else {
             const prevNum = parseInt(stepAttr) - 1;
             const prevStep = document.querySelector(`.bt-step[data-step="${prevNum}"]`);
             prevStep.querySelectorAll('input').forEach(i => { i.disabled = false; i.checked = false; });
             transitionTo(currentStepDiv, prevStep, prevNum);
           }
       }, 2000);
    });
  });

  // --- 6. SOUMISSION FINALE ---
  if(submitBtn) {
      submitBtn.addEventListener('click', function(e) {
        e.preventDefault(); 
        
        if(!form.reportValidity()) return;

        if(isSubmitting) return; 
        isSubmitting = true;

        const emailInput = form.querySelector('input[name="contact[email]"]');
        const email = emailInput ? emailInput.value : '';
        const newsletterCheckbox = form.querySelector('input[name="newsletter_optin"]');
        const isOptIn = newsletterCheckbox ? newsletterCheckbox.checked : false;
        const resultType = finalTypeInput ? finalTypeInput.value : 'Inconnu';
        const destinationUrl = finalDestInput.value || urls.type_A;

        allSteps.forEach(step => step.style.display = 'none');
        if(loadingScreen) {
            loadingScreen.classList.add('visible');
            loadingTextEl.textContent = loadTxt1; 
        }

        try {
            var _learnq = window._learnq || [];
            var currentLang = document.documentElement.lang || 'fr'; 

            _learnq.push(['identify', { '$email': email, '$consent': isOptIn ? ['email'] : [] }]);
            _learnq.push(['track', 'Completed Beauty Tool', {
              'Result': resultType,
              'Newsletter_Opt_In': isOptIn,
              'Quiz_ID': Date.now(),
              'Language': currentLang
            }]);
        } catch (err) { console.warn('Klaviyo Error:', err); }

        const formData = new FormData(form);
        const uniqueUrl = '/contact?t=' + Date.now();
        
        fetch(uniqueUrl, { method: 'POST', body: formData, keepalive: true })
            .catch(err => console.log('Shopify submit ignored:', err));

        setTimeout(() => { if(loadingTextEl) loadingTextEl.textContent = loadTxt2; }, 1500);
        setTimeout(() => { if(loadingTextEl) loadingTextEl.textContent = loadTxt3; }, 3000);

        setTimeout(() => {
            window.location.href = destinationUrl;
        }, 4000);
      });
  }
});